import { GET_ENC, POST_ENC } from "./common/EncryptedHttp";
import { BASE_URL } from "./common/const";

export const GetMedicineCompanyDetail = (params: any) =>
  GET_ENC(`${BASE_URL}/api/MedicineCompany/GetDetail?` + params, null);

export const GetMedicineCompanyList = (params: any) =>
  GET_ENC(`${BASE_URL}/api/MedicineCompany/GetList?` + params, null);

export const CreateMedicineCompany = (data: any) =>
  POST_ENC(`${BASE_URL}/api/MedicineCompany/Create`, data);

export const UpdateMedicineCompany = (data: any) =>
  POST_ENC(`${BASE_URL}/api/MedicineCompany/Update`, data);

export const DeleteMedicineCompany = (data: any) =>
  POST_ENC(`${BASE_URL}/api/MedicineCompany/Delete`, data);






